module.exports = __webpack_public_path__ + "img/hard.e2ef28ff.png";